// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AccountSaveUserSaveUserContactInfoRequestModel } from './accountSaveUserSaveUserContactInfoRequestModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountSaveUserSaveUserRequestModel {
    'userName': string;
    'firstName': string;
    'lastName': string;
    'phone': AccountSaveUserSaveUserContactInfoRequestModel | null;
    'fax': AccountSaveUserSaveUserContactInfoRequestModel | null;
    'email': AccountSaveUserSaveUserContactInfoRequestModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountSaveUserSaveUserRequestModel>> = [
        {
            "name":     "userName",
            "baseName": "userName",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "AccountSaveUserSaveUserContactInfoRequestModel"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "AccountSaveUserSaveUserContactInfoRequestModel"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "AccountSaveUserSaveUserContactInfoRequestModel"
        },
    ];

    static getAttributeTypeMap() {
        return AccountSaveUserSaveUserRequestModel.attributeTypeMap;
    }
}
